import { handleFilters } from "util/filters";
import Page from "webPage/Page";

Page.register([
    '/apprenticeships/apprentices/current-vacancies/',
    '/apprenticeships/apprentices/current-vacancies/page/([0-9]+)/',
], ([page]) => {
    handleFilters();
});
